<template>
  <v-card
    outlined
    class="balance-card"
  >
    <div class="balance-accent" />
    <v-card-text class="balance-body">
      <div class="d-flex flex-column align-center justify-center text-center">
        <v-avatar
          size="48"
          color="success"
          rounded
          class="elevation-2 mb-3"
        >
          <v-icon
            dark
            color="white"
            size="28"
          >
            {{ icons.mdiTrendingUp }}
          </v-icon>
        </v-avatar>
        <p
          class="text-xs text--secondary mb-1 font-weight-medium text-uppercase"
          style="letter-spacing: 0.08em;"
        >
          Saldo Disponível
        </p>
        <h2 class="balance-value success--text font-weight-bold mb-3">
          R$ {{ $money(String(availableLimit ?? 0)) }}
        </h2>
        <v-chip
          small
          color="success"
          outlined
          class="font-weight-medium"
        >
          Disponível
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiTrendingUp } from '@mdi/js'

export default {
  props: {
    dados: {
      type: Array,
      default: () => [],
    },
    availableLimit: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    return {
      icons: { mdiTrendingUp },
    }
  },
}
</script>

<style lang="scss" scoped>
.balance-card {
  position: relative;
  overflow: hidden;
  height: 100%;
}

.balance-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #00C853;
  border-radius: 14px 14px 0 0;
}

.balance-body {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
}

.balance-value {
  font-size: 1.8rem;
  line-height: 1.2;
}
</style>
